import {
  BackofficeUserModel,
  ContractorCompanyTypeEnum,
} from 'api/backofficeApiClient';
import { getLocation } from './locationUtils';
import { BaseAddressModel } from 'api/marketplaceApiClient';

export const getCompanyLocation = (location: BaseAddressModel) => {
  if (!location) return '';

  const { address, city, state, zip } = location;

  return getLocation(address, city, state, zip);
};

export const getInitialCompanyName = (user: BackofficeUserModel | null) => {
  if (!user) return '';

  return user.companyName!;
};

export const getContractorCompanyTypeLabel = (
  type: ContractorCompanyTypeEnum,
) => {
  switch (type) {
    case ContractorCompanyTypeEnum.IC:
      return 'Contractor Company';

    case ContractorCompanyTypeEnum.ParentSC:
      return 'Parent SC Agent';

    default:
      return '';
  }
};
